import { ThemeProvider, type Theme } from '@react-navigation/native'
import { type FC, type ReactNode } from 'react'

import { COLOR_BRAND_BLACK_400, COLOR_BRAND_ORANGE_500, COLOR_BRAND_PURPLE_500, COLOR_WHITE } from '@/lib'

const theme: Theme = {
  dark: true,
  colors: {
    primary: COLOR_WHITE,
    background: 'transparent',
    card: COLOR_BRAND_PURPLE_500,
    text: COLOR_WHITE,
    border: COLOR_BRAND_BLACK_400,
    notification: COLOR_BRAND_ORANGE_500
  },
  fonts: {
    regular: {
      fontFamily: 'Poppins_400Regular',
      fontWeight: '400'
    },
    medium: {
      fontFamily: 'Poppins_500Medium',
      fontWeight: '500'
    },
    bold: {
      fontFamily: 'Poppins_600SemiBold',
      fontWeight: '600'
    },
    heavy: {
      fontFamily: 'Poppins_700Bold',
      fontWeight: '700'
    }
  }
}

export interface NavigationThemeProviderProps {
  children: ReactNode
}

export const NavigationThemeProvider: FC<NavigationThemeProviderProps> = ({ children }) => (
  <ThemeProvider value={theme}>{children}</ThemeProvider>
)
